module.exports = __webpack_public_path__ + "img/个性化实验室.43c39c5d.png";